import React from 'react';
import { Link } from 'react-router-dom'; 
import CartInputField from './CartInputField';
import CartInputAddress from './CartInputAddress';
import CartInputEmail from './CartInputEmail';
import CartInputSelect from './CartInputSelect';

function CartSpedizione(props) { 
/*
  const addressDescr = props.cartData.user && props.cartData.user.indirizzi_spedizione && props.valueAddressId !== "0"? 
      props.cartData.user.indirizzi_spedizione.find(el => el.id_e_user_spedizione === props.valueAddressId) : null;
*/

    const shipmentArray = [
    {
      id: "1",
      name: "Italia - Corriere 24h",
      descr: "Spedizione mediante corriere espresso. Consegna in 24h",
      imgUrl: "",
      imgAlt: "",
      css: "spedizione_01_cart",
      requiredPayment: [], 
    },
    {
      id: "2",
      name: "Ritiro In Sede A Bologna",
      descr: "Ritiro ordine presso la nostra sede in Via Marsala, 15 - 40126 Bologna - Italia",
      imgUrl: "",
      imgAlt: "",
      css: "spedizione_02_cart",
      requiredPayment: [], 
    },
/*    
    {
      id: "3",
      name: "Italia - Corriere 24h",
      descr: "Spedizione mediante corriere espresso. Consegna in 24h",
      imgUrl: "",
      imgAlt: "",
      css: "spedizione_02_cart",
      requiredPayment: [], 
    },
*/    
  ];

  function showError(inputName) {
    if (!props.errList || props.errList.length === 0)
      return null;
    let errList = props.errList.filter((el) => el.id === inputName);
    if (errList.length > 0) {
      return (
        <div className="errore_cart">
          {errList.map((el, i) => (
            <p key={"er_"+i}>{el.msg}</p>
          ))}
        </div>
      )
    }
  } 

  function unregisteredForm() {
    return (
      <div className="info_anagrafica_cart">
        <div className="col-01_anagrafica_cart">
          <CartInputEmail
            required={true}
            type="email"
            lbl="Indirizzo Email"
            name="Email"
            value={props.valueEmail}
            validatedValue={props.validatedEmail}
            change={props.changeEmail}
            changeValidated={props.changeValidatedEmail}
            cssClass="riga_info_cart"
            token={props.token}
            sessionKey={props.sessionKey}
            tokenUpdate={props.tokenUpdate}
            errList={props.errList}
          />
          <CartInputField
            required={true}
            type="text"
            lbl="Nome"
            name="Name"
            value={props.valueName}
            change={props.changeName}
            cssClass="riga_info_cart"
            errList={props.errList}
          />
          <CartInputField
            required={true}
            type="text"
            lbl="Cognome"
            name="LastName"
            value={props.valueLastName}
            change={props.changeLastName}
            cssClass="riga_info_cart"
            errList={props.errList}
          />
          <CartInputField
            required={false}
            type="text"
            lbl="Presso"
            name="Presso"
            value={props.valuePresso}
            change={props.changePresso}
            cssClass="riga_info_cart"
            errList={props.errList}
          />
          <CartInputAddress
            required={true}
            type="text"
            lbl="Indirizzo e numero civico"
            name="Address"
            value={props.valueAddress}
            change={props.changeAddress}
            changeCap={props.changeCap}
            changeCity={props.changeCity}
            changeProv={props.changeProv}
            cssClass="riga_info_cart"
            errList={props.errList}
            googleMapId={props.cfg.googleMapId}
          />
          <div className="semiriga_01_info_cart">
            <CartInputField
              required={true}
              type="text"
              lbl="CAP"
              name="Cap"
              value={props.valueCap}
              change={props.changeCap}
              cssClass="riga_info_cart"
              errList={props.errList}
            />
          </div>
          <div className="semiriga_02_info_cart">
            <CartInputField
              required={true}
              type="text"
              lbl="Citt&agrave;"
              name="City"
              value={props.valueCity}
              change={props.changeCity}
              cssClass="riga_info_cart"
              errList={props.errList}
            />
          </div>
          <div className="semiriga_01_info_cart">
            {props.provinceList && props.provinceList.length > 0 ? (
              <CartInputSelect
                required={true}
                lbl="Provincia"
                name="Province"
                value={props.valueProv}
                options={props.provinceList}
                emptyOption={["", ""]}
                change={props.changeProv}
                composeText={composeProvinceText}
                valName="abbr"
                cssClass="riga_info_cart"
                errList={props.errList}
              />
            ) : (
              <CartInputField
                required={true}
                type="text"
                lbl="Provincia"
                name="Province"
                value={props.valueProv}
                change={props.changeProv}
                cssClass="riga_info_cart"
                errList={props.errList}
              />
            )}
          </div>
          <div className="semiriga_02_info_cart">
            <CartInputField
              required={true}
              type="phone"
              lbl="Telefono"
              name="Phone"
              value={props.valuePhone}
              change={props.changePhone}
              cssClass="riga_info_cart"
              errList={props.errList}
            />
          </div>
        </div>

        <div className="col-02_anagrafica_cart">
          <div className="riga_note_cart">
            <label>Note aggiuntive:</label>
            <textarea
              className="note_cart"
              onChange={(e) => props.changeNotes(e.target.value)}
              name="Notes"
              value={props.valueNotes}
            ></textarea>
          </div>
          <div className="spedizioni_cart">
            <p>Scegli la modalità di spedizione *</p>
            {shipmentArray.map((el) => {
              if (
                !props.paymentId ||
                props.paymentId === "" ||
                el.requiredPayment.length === 0 ||
                el.requiredPayment.indexOf(props.paymentId) >= 0
              ) {
                return (
                  <CartInputField
                    key={el.id}
                    required={false}
                    type="radio"
                    lbl={el.name}
                    name="Shipment"
                    value={el.id}
                    change={props.changeShipment}
                    cssClass={el.css}
                    labelRight={true}
                    curVal={props.valueShipment}
                    imgUrl={el.imgUrl}
                    imgAlt={el.imgAlt}
                  />
                );
              } else return null;
            })}
            {showError("Shipment")}
          </div>

          <CartInputField
            required={false}
            type="checkbox"
            lbl="Voglio assicurare il pacco + € 2.00"
            name="ShipmentInsurance"
            value={props.valueShipmentInsurance}
            change={props.changeShipmentInsurance}
            cssClass="assicurazione_cart"
            labelRight={true}
            errList={props.errList}
          />
        </div>
      </div>
    );
  }

  function composeProvinceText(el) {
    return el.abbr;
  }

  function composeAddressText(el) {
    let text =
      el.nome + " "+ el.cognome +", " + el.indirizzo;
    if (el.presso.length > 0) 
      text += " presso " + el.presso;
    text += ", " + el.cap + " " + el.citta + " (" + el.provincia + "), tel. "+el.telefono;
    return text;
  }

  function registeredForm() {
    return (
      <div className="info_anagrafica-reg_cart">
        <CartInputField
          required={true}
          type="email"
          lbl="Indirizzo Email"
          name="Email"
          value={props.valueEmail}
          change={props.changeEmail}
          cssClass="riga_info_cart"
          //token={props.token}
          //sessionKey={props.sessionKey}
          //tokenUpdate={props.tokenUpdate}
          readonly={true}
          errList={props.errList}
        />
        <div className="clear" />

        <CartInputSelect
          required={true}
          lbl="Seleziona l'indirizzo di spedizione"
          name="AddressId"
          value={props.valueAddressId}
          options={props.cartData.user.indirizzi_spedizione}
          hideIfEmpty={true}
          change={props.changeAddressId}
          composeText={composeAddressText}
          valName="id_e_user_spedizione"
          cssClass="riga_info_cart"
          errList={props.errList}
        />
        <div className="clear" />

        <div className="indirizzo_extra_cart">
          {props.cartData.user.indirizzi_spedizione.length === 0? showError("AddressId") : null}
          <Link to="/profilo/indirizzi">
            <div
              className="indirizzo_extra_cart_img"
              //onClick={(e) => addShippingAddress()}
            >
              <img
                src="/images/indirizzo_on.svg"
                alt="Indirizzo alternativo"
                title="Indirizzo alternativo"
              />
            </div>
            <p>Aggiungi o modifica indirizzo di spedizione</p>
          </Link>
        </div>
        <div className="clear" />

        <div className="riga_note_cart">
          <label>Note aggiuntive:</label>
          <textarea
            className="note_cart"
            onChange={(e) => props.changeNotes(e.target.value)}
            name="Notes"
            value={props.valueNotes}
          ></textarea>
        </div>
        <div className="clear" />

        <div className="spedizioni_cart">
          <p>Scegli la modalità di spedizione *</p>
          {shipmentArray.map((el) => {
            if (
              !props.paymentId ||
              props.paymentId === "" ||
              el.requiredPayment.length === 0 ||
              el.requiredPayment.indexOf(props.paymentId) >= 0
            ) {
              return (
                <CartInputField
                  key={el.id}
                  required={false}
                  type="radio"
                  lbl={el.name}
                  name="Shipment"
                  value={el.id}
                  change={props.changeShipment}
                  cssClass={el.css}
                  labelRight={true}
                  curVal={props.valueShipment}
                  imgUrl={el.imgUrl}
                  imgAlt={el.imgAlt}
                />
              );
            } else return null;
          })}
          {showError("Shipment")}
        </div>
        <div className="clear" />

        <CartInputField
          required={false}
          type="checkbox"
          lbl="Voglio assicurare il pacco + € 2.00"
          name="ShipmentInsurance"
          value={props.valueShipmentInsurance}
          change={props.changeShipmentInsurance}
          cssClass="assicurazione_cart"
          labelRight={true}
          errList={props.errList}
        />
        
      </div>
    );

  }

  //console.log("FormShipment: "+FormShipment);
  //console.log(props.errList);
  return (
    <form>
      <div className="anagrafica_cart">
        <div className="titolo_anagrafica_cart">
          <h2>{props.title}</h2>
        </div>
          {props.cartData.user && props.cartData.user.id_e_user !== "0"? registeredForm() : unregisteredForm()}
      </div>
    </form>
  );
}

export default CartSpedizione;